// Criterio ÚNICO de "¿esta rutina cae en este día?" en el frontend.
// Es el espejo del scope `Routine.for_date` del backend (app/models/routine.rb).
// Si cambia uno, tiene que cambiar el otro.
//
//   - Con scheduled_date → cae SOLO en esa fecha exacta.
//   - Sin scheduled_date (rutina legacy, previa al calendario) → cae por día de
//     semana, repitiéndose todas las semanas.
//
// Filtrar solo por scheduled_day hacía que una serie recurrente (una fila por
// semana, todas con el mismo scheduled_day) apareciera completa en cada día.

export interface SchedulableRoutine {
  scheduled_date?: string | null
  scheduled_day?: number | null
}

export function toISODate(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  return `${y}-${m}-${day}`
}

export function routineOnDay(routine: SchedulableRoutine, day: Date): boolean {
  if (routine.scheduled_date) {
    return routine.scheduled_date.slice(0, 10) === toISODate(day)
  }
  // Sin fecha ni día de semana no hay forma de ubicarla: no cae en ningún día.
  if (routine.scheduled_day == null) return false
  return routine.scheduled_day === day.getDay()
}

export function routinesOnDay<T extends SchedulableRoutine>(routines: T[], day: Date): T[] {
  return routines.filter((r) => routineOnDay(r, day))
}
